// Root-inclusive lookups: the root itself when it matches, then its descendants.
export function findAll(root, selector) {
  const matches = root.matches?.(selector) ? [root] : [];
  return matches.concat(Array.from(root.querySelectorAll?.(selector) ?? []));
}

export function findFirst(root, selector) {
  return findAll(root, selector)[0] ?? null;
}

export const RUNTIME_ROOT_SELECTOR = '[data-bp-runtime="v2"]';

// The shared header swaps the desktop nav for the drawer at this width and below.
export const COMPACT_MAX_WIDTH = 1279;

export function prefersReducedMotion(view) {
  return Boolean(view?.matchMedia?.('(prefers-reduced-motion: reduce)').matches);
}

export function slugify(value) {
  return String(value ?? '').trim().toLowerCase().replace(/[^a-z0-9]+/gu, '-').replace(/^-+|-+$/gu, '');
}
